import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCustomerAdditionalContactsResponse } from '@/api/agency/customers/get-customer-additional-contacts'
import { departments } from '@/shared/resources/departments'
import { states } from '@/shared/resources/states'

export const mockGetCustomerAdditionalContacts = http.get(
  '/my-business/api/agency/v1/customers/:customerId/contacts/additional-contacts',
  () => {
    const data: GetCustomerAdditionalContactsResponse = {
      data: Array.from({ length: 5 }, () => {
        return {
          alphaId: faker.string.uuid(),
          departmentCode: faker.helpers.arrayElement(
            departments.map((i) => i.value),
          ),
          email: faker.internet.email(),
          name: faker.person.fullName(),
          phone: faker.string.numeric(13),
          address: {
            address: faker.location.streetAddress(),
            cityId: faker.number.int(3),
            countryCode: 'BR',
            departmentEnum: faker.helpers.arrayElement(
              departments.map((i) => i.value),
            ),
            neighborhood: faker.lorem.word(),
            number: faker.string.numeric(3),
            stateCode: faker.helpers.arrayElement(states.map((i) => i.value)),
            zipCode: faker.location.zipCode(),
            complement: faker.lorem.word(),
          },
        }
      }),
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
